// Environment variables utility
// This helps with type safety and default values

// IMPORTANT: For client-side code, environment variables are embedded at build time
// This means the values here will be compiled into the JavaScript bundle
// and won't change at runtime unless the app is rebuilt

// Log environment variables for debugging
if (typeof window !== "undefined") {
  console.log("Client-side environment variables:")
  console.log("NEXT_PUBLIC_API_URL:", process.env.NEXT_PUBLIC_API_URL)
  console.log("NEXT_PUBLIC_ADMIN_SERVICE_API_ENDPOINT:", process.env.NEXT_PUBLIC_ADMIN_SERVICE_API_ENDPOINT)
  console.log("NEXT_PUBLIC_USE_MOCK_DATA:", process.env.NEXT_PUBLIC_USE_MOCK_DATA)
  console.log("NEXT_PUBLIC_BASE_PATH:", process.env.NEXT_PUBLIC_BASE_PATH)
  console.log("NEXT_PUBLIC_BUILD_ENV:", process.env.NEXT_PUBLIC_BUILD_ENV)
  console.log("NEXT_PUBLIC_COMMISSION_SERVICE_API_URL:", process.env.NEXT_PUBLIC_COMMISSION_SERVICE_API_URL)
}

// Application environment variables
// DO NOT provide default values here - they will override environment variables
export const env = {
  // Monolith API base URL
  apiUrl: process.env.NEXT_PUBLIC_API_URL || "#{API_URL}#",

  // Admin Service API Endpoint
  adminServiceApiEndpoint: process.env.NEXT_PUBLIC_ADMIN_SERVICE_API_ENDPOINT || "#{ADMIN_SERVICE_API_ENDPOINT}#",

  // Whether to use mock data instead of real API calls
  useMockData: process.env.NEXT_PUBLIC_USE_MOCK_DATA || "false",

  // Build environment
  buildEnv: process.env.NEXT_PUBLIC_BUILD_ENV || "#{BUILD_ENV}#",

  // Base path
  basePath: process.env.NEXT_PUBLIC_BASE_PATH || "#{BASE_PATH}#",

  // Commission Service API URL
  commissionServiceApiUrl: process.env.NEXT_PUBLIC_COMMISSION_SERVICE_API_URL || "#{COMMISSION_SERVICE_API_URL}#",

  // Rollbar
  rollbarAccessToken: process.env.NEXT_PUBLIC_ROLLBAR_ACCESS_TOKEN || "#{ROLLBAR_ACCESS_TOKEN}#",
  rollbarEnvironment: process.env.NEXT_PUBLIC_ROLLBAR_ENVIRONMENT || "#{ROLLBAR_ENVIRONMENT}#",
  rollbarEnabled: (process.env.NEXT_PUBLIC_ROLLBAR_ENABLED || "#{ROLLBAR_ENABLED}#") === "true",
}

// Log the final env object for debugging
if (typeof window !== "undefined") {
  console.log("Final env object:", env)
}
